import {
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
} from "@mui/material";

const formatCurrency = (value, currency) =>
  `${currency}${Number((value / 100) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const formatNumber = (value) => Number(value || 0).toLocaleString();

export default function ValueCountTable({ title, data, currency = "₦" }) {
  return (
    <Card sx={{ borderRadius: 3, width: "100%" }}>
      <CardContent sx={{ p: 0 }}>
        <Typography variant="h6" sx={{ pl: 2, pt: 2, pb: 2 }}>
          {title}
        </Typography>
        <Table
          sx={{
            tableLayout: "fixed",
            width: "100%",
          }}
        >
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="center">Sales</TableCell>
            <TableCell align="right">Revenue</TableCell>
          </TableRow>

            {data.map((row) => (
              <TableRow
                key={row.name}
                hover
              >
                <TableCell>
                  <Typography variant="body2">{row.name}</Typography>
                </TableCell>

                <TableCell align="center">
                  {formatNumber(row.count)}
                </TableCell>

                <TableCell align="right">
                  <Typography variant="body2" fontWeight={600}>{formatCurrency(row.value, currency)}</Typography>
                </TableCell>
              </TableRow>
            ))}
        </Table>
      </CardContent>
    </Card>
  );
}
